import { ChainSchema, ConnectionConfigSchema, SmartAccountClientOptsSchema, } from "@aa-sdk/core";
import { Alchemy } from "alchemy-sdk";
import z from "zod";
export const AlchemyChainSchema = z.custom((chain) => {
    const chain_ = ChainSchema.parse(chain);
    return chain_.rpcUrls.alchemy != null;
}, "chain must include an alchemy rpc url. See `createAlchemyChain` or import a chain from `@account-kit/infra`.");
export const AlchemyProviderConfigSchema = ConnectionConfigSchema.and(z.object({
    chain: AlchemyChainSchema,
    opts: SmartAccountClientOptsSchema.optional().default(SmartAccountClientOptsSchema.parse({})),
}));
export const AlchemySdkClientSchema = z.instanceof(Alchemy);
//# sourceMappingURL=schema.js.map